<script setup lang="ts">
import { AppSelectSearchable } from '@shared/ui/selects'

import { useSelectPaidMath } from '../../model/payment-policy/select-paid-math.hook'

defineOptions({
  name: 'SelectPaidMath',
})

const {
  modelValue,
  label,
  placeholder,
  options,
  hasMore,
  loading,
  selectedOption,
  disabled,
  onSearch,
  onLoadMore,
  onOpen,
} = useSelectPaidMath()
</script>

<template>
  <AppSelectSearchable
    v-model="modelValue"
    :options="options"
    :label="label"
    :placeholder="placeholder"
    :selected-option="selectedOption"
    :has-more="hasMore"
    :loading="loading"
    :disabled="disabled"
    clearable
    infinite
    @search="onSearch"
    @load-more="onLoadMore"
    @open="onOpen"
  />
</template>
